<template>
    <v-row>
        <v-col
            cols="12"
            :sm="smCol"
        >
            <v-select
                @input="updateAnswerTypeFilter"
                v-model="answerTypeFilter"
                :items="answerTypes"
                label="Tipe jawaban"
                hide-details
                class="mt-0 pt-0"
            ></v-select>
        </v-col>

        <v-col
            cols="12"
            :sm="smCol"
        >
            <v-select
                @input="updateFieldFilter"
                v-model="fieldFilter"
                :items="fields"
                label="Bidang"
                hide-details
                class="mt-0 pt-0"
            ></v-select>
        </v-col>

        <v-col
            v-if="hasDiscussionGroup"
            cols="12"
            sm="4"
            class="text-center"
        >
            <question-discussion />
        </v-col>
    </v-row>
</template>

<script>
import QuestionDiscussion from './QuestionDiscussion.vue'
import { sync, get } from 'vuex-pathify'

export default {
    props: {
        tryoutHash: {
            type: String,
            required: true,
        },
    },

    components: {
        QuestionDiscussion,
    },

    data: () => ({
        fields: [],
        answerTypes: [
            { text: 'Semua', value: 'all' },
            { text: 'Jawaban benar', value: 'correct' },
            { text: 'Jawaban salah', value: 'incorrect' },
            { text: 'Tidak dijawab', value: 'unanswered' },
            { text: 'Ragu', value: 'flagged' },
        ],
    }),

    computed: {
        tryoutFieldLocalStorageCacheKeyName() {
            return `tryout_field_${this.tryoutHash}`
        },
        fieldFilter: sync('explanation/fieldFilter'),
        answerTypeFilter: sync('explanation/answerTypeFilter'),
        hasDiscussionGroup: get('enrollment/selected@has_discussion_group'),
        smCol() {
            return this.hasDiscussionGroup == 1 ? 4 : 6
        },
    },

    methods: {
        updateAnswerTypeFilter() {
            this.$tracking.event.explanation.filterAnswerType(
                this.answerTypeFilter
            )
            this.updateFilter()
        },

        updateFieldFilter() {
            const selectedField =
                this.fieldFilter != 'all'
                    ? this.fields.find(
                          (field) => field.value == this.fieldFilter
                      ).text
                    : 'all'
            this.$tracking.event.explanation.filterField(selectedField)
            this.updateFilter()
        },

        updateFilter() {
            this.$store.set('explanation/currentPage', 1)
            this.$store.dispatch('explanation/getData')
        },
    },

    async created() {
        let fields = localStorage.getItem(
            this.tryoutFieldLocalStorageCacheKeyName
        )

        if (!fields) {
            const response = await this.$apiv2.get(
                `tryout/${this.tryoutHash}/field`
            )
            fields = response.data.fields.map((field) => ({
                text: field.title,
                value: field.id,
            }))
            fields.unshift({
                text: 'Semua',
                value: 'all',
            })
            localStorage.setItem(
                this.tryoutFieldLocalStorageCacheKeyName,
                JSON.stringify(fields)
            )
        } else {
            fields = JSON.parse(fields)
        }

        this.fields = fields
    },
}
</script>
